
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`The preference for the types of work for a position.`}</p>
    <p>{`Caution: this is currently under development and may be changed or removed without notice.`}</p>
    <p>{`This is only available for Apply with SEEK candidate profiles.
For candidate applications, uploaded candidate profiles & purchased profiles this will be an empty list.`}</p>
    <p>{`Currently, four codes are defined:`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li"><inlineCode parentName="p">{`Casual`}</inlineCode>{` indicates a casual position.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><inlineCode parentName="p">{`ContractTemp`}</inlineCode>{` indicates a fixed-length contract position.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><inlineCode parentName="p">{`FullTime`}</inlineCode>{` indicates a full-time position.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><inlineCode parentName="p">{`PartTime`}</inlineCode>{` indicates a part-time position.`}</p>
      </li>
    </ul>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;